/**
 * Returns the correct human label for a quiz/poll card badge.
 *
 * Historically every card with `metadata.is_quiz === true` was labelled
 * "Lyrics quiz" even when the underlying content was a trivia/fact quiz
 * (`metadata.quiz_type === 'fact'`) or any future non-lyric quiz type.
 * This helper picks the right label from `metadata.quiz_type` so ONLY
 * true lyric-snippet quizzes carry the "Lyrics quiz" badge.
 *
 * Non-quiz polls get "Quick poll".
 */
export function quizLabel(metadata) {
  if (!metadata?.is_quiz) return 'Quick poll';
  const type = metadata.quiz_type;
  const genre = metadata.song_info?.genre;
  if (type === 'lyrics') return `Lyrics quiz${genre ? ` · ${genre}` : ''}`;
  if (type === 'fact' || type === 'trivia') return 'Trivia quiz';
  // Unknown/legacy quiz_type — fall back to a neutral, accurate label
  // instead of misclaiming "Lyrics quiz".
  return 'Quiz';
}
